import RadioCheck from "../vectors/RadioCheck";

export default function Radio({checked}) {
    return (
        <span className="p-2 grow-0 shrink-0 flex-auto overflow-visible text-[1.5rem] text-center transition-colors rounded-[50%] border-0 cursor-pointer m-0 inline-flex outline-0 relative items-center select-none align-middle justify-center decoration-0 bg-transparent appearance-none no-highlights"
              aria-disabled="false">
            <span className="w-full flex">
                <input className="top-0 left-0 w-full cursor-[inherit] h-full m-0 opacity-0 p-0 z-1 absolute" type="radio" value="" checked="" />
                <div className="flex relative">
                    <RadioCheck checked={checked} />
                </div>
            </span>
            <span className="MuiTouchRipple-root"></span>
        </span>
    )
}